import { useEffect, useState } from 'react';
import ReportFilter from '../../components/reportFilter';
import { useReportContext } from '../../components/reportContext';
import { useGetAdminAssessmentReportValuesMutation, useUpdateAdminAssessmentReportValuesMutation,
  useGetAssignmentReportValuesMutation, useUpdateAssignmentReportValuesMutation
} from '../../../../features/authentication/persistApiSlice';
import CustomToast from '../../../../components/Toast';
import { useNavigate } from 'react-router';

const SingleAssessmentReport = () => {
  const navigate = useNavigate();
  const { assignmentId, setAssignmentId, selectedClassId, setSelectedClassId, selectedStudentId, 
    selectedCourseId, setSelectedCourseId, startDate, setStartDate, endDate, setEndDate, isAllReport, setIsAllReport, 
    studentToIncludeTab, setStudentToIncludeTab, setIsAssessment,setReportType} = useReportContext();

  const [getAssessmentReportValues] = useGetAdminAssessmentReportValuesMutation();
  const [updateAssessmentReportValues] = useUpdateAdminAssessmentReportValuesMutation();
  const [getAssignmentReportValues] = useGetAssignmentReportValuesMutation();
  const [updateAssignmentReportValues] = useUpdateAssignmentReportValuesMutation();

  const [reportTitle, setReportTitle] = useState('');
  const [reportInfo, setReportInfo] = useState('');
  const [reportName, setReportName] = useState('');
  const [persistValueLoaded, setPersistValueLoaded] = useState(false);

  const reportType = window.location.href.split('/').pop();

  const handleCreateReport = () => {
    if(studentToIncludeTab == 2 && selectedStudentId == 0){
      CustomToast('Please select a student to create report.','error');
      return;
    }
  
    if(reportType === 'single-admin-assessment')
      UpdateAssessmentPersistData();
    else
      UpdateAssignmentPersistData();
    handleReportNavigation();
  };

  useEffect(() => {
    getReportDetails();
    setIsAllReport(false);
  }, []);

  const getReportDetails =()=>{
    if(reportType === 'single-admin-assessment')
    { 
      setReportType('single-admin-assessment');
      setIsAssessment(true);
      setReportName('Single Assessment');
      setReportTitle('Single Admin Assessment Report');
      setReportInfo('The Single Admin Assessment Report shows student performance for published assessments, providing a breakdown by various categories.');
      getAssessmentPersistData();
    }
    else if(reportType === 'single-assignment')
    {
      setReportType('single-assignment');
      setIsAssessment(false);
      setReportName('Single Assignment');
      setReportTitle('Single Assignment Report');
      setReportInfo('The Single Assignment Report shows student performance for individual assignments or for all assignments in a course (currently assigned and unassigned), providing a breakdown by various categories.');
      getAssignmentPersistData();
    }
  };

  const getAssignmentPersistData = async() =>
  {
    var persistData =await getAssignmentReportValues().unwrap();
    setSelectedCourseId(persistData.courseId);
    setSelectedClassId(persistData.classId);
    setStartDate(persistData.startDate);
    setEndDate(persistData.endDate);
    setAssignmentId(persistData.assignmentId);
    setStudentToIncludeTab(persistData.studentToInclude);
    setPersistValueLoaded(true);
  };

  const UpdateAssignmentPersistData = async() => {
    var options={
      'courseId': selectedCourseId,
      'isAllReport': isAllReport,
      'assignmentId': assignmentId,
      'startDate': startDate,
      'endDate': endDate,
      'studentToInclude': studentToIncludeTab,
      'studentId': selectedStudentId,
      'classId': selectedClassId
    };
    await updateAssignmentReportValues(options);
  };

  const getAssessmentPersistData = async() =>
  {
    var persistData = await getAssessmentReportValues().unwrap();
    setSelectedCourseId(persistData.courseId);
    setSelectedClassId(persistData.classId);
    setStartDate(persistData.startDate);
    setEndDate(persistData.endDate);
    setAssignmentId(persistData.assignmentId);
    setStudentToIncludeTab(persistData.studentToInclude);
    setPersistValueLoaded(true);
  };

  const UpdateAssessmentPersistData = async() => {
    var options={
      'courseId': selectedCourseId,
      'isAllReport': isAllReport,
      'assignmentId': assignmentId,
      'startDate': startDate,
      'endDate': endDate,
      'studentToInclude': studentToIncludeTab,
      'studentId': selectedStudentId,
      'classId': selectedClassId
    };
    await updateAssessmentReportValues(options);
  };

  const handleReportNavigation = async() => {
    if(studentToIncludeTab == 2)
      navigate(`${assignmentId}/student_session_report?studentId=${selectedStudentId}&incompleteScoring=${false}&studentsToInclude=${studentToIncludeTab}`);
    else
      navigate(`${assignmentId}/class_cumulative_report?studentsToInclude=${studentToIncludeTab}`);
  };

  return (
    <>
      {persistValueLoaded &&
        <ReportFilter
          handleCreateReport={handleCreateReport}
          isTOTReport={false}
          backOnClick={() => window.history.back()}
          description={reportInfo}
          type={reportName}
          title={reportTitle}
        />
      }
    </>
  );
};

export default SingleAssessmentReport;